import * as React from 'react';
import Slider from '@af-common/Common/_components/Slider';
import { Trans } from 'react-i18next';
import ModuleDuplicateContainer from '../../_containers/ModuleDuplicateContainer';

export type Props = {
	moduleId?: string
	hue?: number,
	onHueChange?: Function,
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class ModuleHueSettings extends React.Component<Props> {
	private onChange = (e:React.ChangeEvent, v:any) => {
		e.stopPropagation();
		this.props.onHueChange(v);
	}

	render = () => <>
		<div style={{padding: "0 8px"}}>
			<label htmlFor={this.props.moduleId + " Hue"}><T>Hue</T></label>
			<Slider name={this.props.moduleId + " Hue"} onChange={this.onChange} value={this.props.hue} step={0.01} min={0} max={1} />
		</div>

		<div className="actions-wrapper">
			<ModuleDuplicateContainer moduleId={this.props.moduleId}/>
		</div>
	</>
}